import type { IPatientSchedule } from 'features/Home/interfaces/IInfoSchedule'
import { getScheduleStaffColor, getScheduleStaffId } from './scheduleInstance'

export const applyStaffColorToken = (
  element: HTMLElement,
  event: Pick<IPatientSchedule, 'consultation_staff'>,
): void => {
  const color = getScheduleStaffColor(getScheduleStaffId(event))
  element.style.setProperty('--staff-color', color)
  element.style.setProperty('--staff-color-ink', '#fff')
}

export const applyStaffFocus = (
  element: HTMLElement,
  event: Pick<IPatientSchedule, 'consultation_staff'>,
  focusedStaffIds: number[] | null | undefined,
): void => {
  if (!focusedStaffIds?.length) {
    element.classList.remove('schedule-event--dim', 'schedule-event--focus')
    return
  }

  const on = focusedStaffIds.includes(getScheduleStaffId(event))
  element.classList.toggle('schedule-event--dim', !on)
  element.classList.toggle('schedule-event--focus', on)
}
